const columnPreviewGifs = {
  COLUMN_BACKGROUND_GIF: './images/element-settings/column-background.gif',
  COLUMN_HORIZONTAL_CONTENT_ALIGNMENT_GIF:
    './images/element-settings/column-horizontal-content-alignment.gif',
  COLUMN_VERTICAL_CONTENT_ALIGNMENT_GIF:
    './images/element-settings/column-vertical-content-alignment.gif',
  COLUMN_CORNERS_GIF: './images/element-settings/column-corners.gif',
  COLUMN_VERTICAL_PADDING_GIF: './images/element-settings/column-vertical-padding.gif',
  COLUMN_HORIZONTAL_PADDING_GIF: './images/element-settings/column-horizontal-padding.gif',
};

const columnsPreviewGifs = {
  COLUMNS_BACKGROUND_GIF: './images/element-settings/columns-background.gif',
  COLUMNS_HORIZONTAL_CONTENT_ALIGNMENT_GIF:
    './images/element-settings/columns-horizontal-content-alignment.gif',
  COLUMNS_VERTICAL_CONTENT_ALIGNMENT_GIF:
    './images/element-settings/columns-vertical-content-alignment.gif',
  COLUMNS_AMOUNT_GIF: './images/element-settings/columns-amount.gif',
  COLUMNS_WIDTH_GIF: './images/element-settings/columns-width.gif',
  COLUMNS_HEIGHT_GIF: './images/element-settings/columns-height.gif',
  COLUMNS_VERTICAL_GAP_GIF: './images/element-settings/columns-vertical-gap.gif',
  COLUMNS_HORIZONTAL_GAP_GIF: './images/element-settings/columns-horizontal-gap.gif',
};

const previewGifs = {
  ...columnPreviewGifs,
  ...columnsPreviewGifs,
};

export { columnPreviewGifs, columnsPreviewGifs };
export default previewGifs;
